export default __webpack_public_path__ + "static/media/XEMP-15.21933c6e.jpg";